<template>
  <div>

    <div class="reports-list-action-buttons">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="openAddReportModal()"
      >
        <i class="fas fa-plus-circle"/>
        Dodaj raport
      </div>
      <div
          v-if="!commonModule.centralInstance"
          class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm ms-2"
          @click="syncFromCentral()"
      >
        <i class="fas fa-sync-alt"/>
        Pobierz raporty centralne
      </div>
    </div>

    <div class="reports-list-stage">
      <div class="reports-list-table-container">
        <CommonTable2
            ref="reportsCommonTable"
            :table="tableData"
            rowIdentifier="guid"
            @onItemAction="runAction($event)"
            @onSort="sort($event)"
            @onMassAction="runMassAction($event)"
            @onCheckItem="checkAction($event)"
            :key="refreshTable"
            :currentPage="currentPage"
            :totalRows="reportsModule.getReportsListTotal"
            :totalPages="reportsModule.getReportsListPagesCount"
            :showPaginationTop="true"
            :showPaginationBottom="true"
            :multiselect="true"
            @onPageChange="currentPage = $event"
            :sortColumn="sortingKey"
            :sortDirection="sortingDirection"
            :showMassActions="true"
            :showRowActions="true"
            :showCheckboxColumn="true"
            :stickyScrollbarBottom="0"
        />
      </div>
    </div>

    <!-- Reports Form Modal -->
    <ReportsFormModal
        v-if="showReportFormModal"
        v-model:showModal="showReportFormModal"
        :title="reportFormModalTitle"
        :reportGuid="editReportGuid"
        @onSave="onReportSaved()"
        @onClose="showReportFormModal = false"
    />

    <!-- Folder Info Modal -->
    <b-modal
        v-model="showFolderInfoModal"
        id="report-folder-info-modal"
        scrollable
        title="Informacje o folderze raportu"
        title-class="font-18"
        size="lg"
        ok-only
        ok-title="Zamknij"
    >
      <div v-if="folderInfoData">
        <div class="mb-3">
          <label class="form-label fw-bold">Ścieżka folderu:</label>
          <input type="text" class="form-control font-monospace" :value="folderInfoData.folderPath" readonly/>
        </div>
        <div>
          <label class="form-label fw-bold">Pliki w folderze:</label>
          <div v-if="folderInfoData.files && folderInfoData.files.length > 0">
            <ul class="list-group list-group-flush">
              <li v-for="(file, idx) in folderInfoData.files" :key="idx" class="list-group-item py-1 px-0 small font-monospace">
                <i class="fas fa-file me-2 text-muted"></i>{{ file }}
              </li>
            </ul>
          </div>
          <div v-else class="text-muted small">Brak plików w folderze. W przyszłości pojawi się możliwość wyświetlania bieżących plików z aptek oczekujących na przetworzenie oraz tych wyeksportowanych ręcznie i zarządzania nimi.</div>
        </div>
      </div>
      <div v-else class="text-muted">Ładowanie danych...</div>
    </b-modal>

  </div>
</template>

<script>
import {BModal} from "bootstrap-vue-next";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import ReportsFormModal from "@/views/ReportsManager/ReportsFormModal.vue";
import {log} from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {useReportsManagerModule} from "@/state/pinia/reportsManagerModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import Swal from "sweetalert2";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useSimplepharmAuthModule} from "@/state/pinia";

export default {
  name: "ReportsListView",
  components: {
    BModal,
    CommonTable2,
    ReportsFormModal,
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "DESC",
      sortingKey: "updatedAt",
      searchAndFilterRequest: null,
      refreshTable: true,

      // Modals
      showReportFormModal: false,
      reportFormModalTitle: "Dodaj raport",
      editReportGuid: null,

      // Folder info modal
      showFolderInfoModal: false,
      folderInfoData: null,

      availableHeaders: [
        {
          text: "Nazwa",
          key: "name",
          type: "text",
          sortable: true,
          width: "200px",
        },
        {
          text: "Opis",
          key: "description",
          type: "text",
          sortable: false,
          width: "250px",
        },
        {
          text: "Typ raportu",
          key: "reportType",
          type: "text",
          sortable: true,
          width: "180px",
        },
        {
          text: "Data aktualizacji",
          key: "updatedAt",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          width: "160px",
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          width: "280px",
          actions: [
            {
              text: "",
              icon: "fas fa-edit",
              action: "edit",
              enabled: true,
              tooltip: "Edytuj raport",
              class: "btn btn-info btn-sm table-actions-button",
            },
            {
              text: "",
              icon: "fas fa-file-import",
              action: "import-files",
              enabled: true,
              tooltip: "Importuj pobrane pliki",
              class: "btn btn-primary btn-sm table-actions-button",
            },
            {
              text: "",
              icon: "fas fa-file-export",
              action: "export-full-data",
              enabled: true,
              tooltip: "Eksportuj pełne dane",
              class: "btn btn-warning btn-sm table-actions-button",
            },
            // { TODO: MOVE IT TO REPORT VIEWER SCOPE - IN THIS VIEW ALL REPORTS SHOULD BE CONSIDERED AS SOURCE DATA - THAT MEANS FILES COULD BE OF ENORMOUS SIZES IT WOULD NOT BE ABLE TO SENT VIA E-MAIL
            //   text: "",
            //   icon: "fas fa-envelope",
            //   action: "send-email",
            //   enabled: true,
            //   tooltip: "Wyślij raportem przez email",
            //   class: "btn btn-secondary btn-sm table-actions-button",
            // },
            {
              text: "",
              icon: "fas fa-server",
              action: "send-ftp",
              enabled: true,
              tooltip: "Wyślij raport przez FTP",
              class: "btn btn-secondary btn-sm table-actions-button",
            },
            {
              text: "",
              icon: "fas fa-broom",
              action: "clean-files",
              enabled: true,
              tooltip: "Wyczyść stare pliki",
              class: "btn btn-outline-secondary btn-sm table-actions-button",
            },
            {
              text: "",
              icon: "fas fa-folder-open",
              action: "folder-info",
              enabled: true,
              tooltip: "Informacje o folderze",
              class: "btn btn-outline-info btn-sm table-actions-button",
            },
          ],
        },
      ],
    };
  },
  computed: {
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    reportsModule() {
      return useReportsManagerModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
  },
  methods: {
    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.toggleSortingDirection();
      this.refreshReportsList();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      log.log(event);
    },
    runAction(event) {
      const action = event.action.action;
      const item = event.itemData;
      log.log("runAction:", action, item);

      if (action === "edit") {
        this.openEditReportModal(item.guid);
      } else if (action === "generate") {
        this.generateReport(item.guid, item.name);
      } else if (action === "fetch-data-from-ftp") {
        this.fetchDataFromDrugstores(item.guid, item.name);
      } else if (action === "import-files") {
        this.importFetchedFiles(item.guid, item.name);
      } else if (action === "export-full-data") {
        this.exportFullData(item.guid, item.name);
      } else if (action === "send-email") {
        this.sendReportByEmail(item.guid, item.name);
      } else if (action === "send-ftp") {
        this.sendReportByFtp(item.guid, item.name);
      } else if (action === "reset-data") {
        this.resetReportData(item.guid, item.name);
      } else if (action === "clean-files") {
        this.cleanOldReportFiles(item.guid, item.name);
      } else if (action === "folder-info") {
        this.showFolderInfo(item.guid);
      } else if (action === "delete") {
        this.deleteReport(item.guid, item.name);
      }
    },
    runMassAction(event) {
      log.log(event);
    },

    openAddReportModal() {
      this.editReportGuid = null;
      this.reportFormModalTitle = "Dodaj nowy raport";
      this.showReportFormModal = true;
    },
    openEditReportModal(reportGuid) {
      this.editReportGuid = reportGuid;
      this.reportFormModalTitle = "Edytuj raport";
      this.showReportFormModal = true;
    },
    onReportSaved() {
      this.showReportFormModal = false;
      this.refreshReportsList();
    },

    syncFromCentral() {
      Swal.fire({
        title: "Synchronizacja z centrali",
        text: "Czy na pewno zsynchronizować raporty z centrali?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Synchronizuj",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Synchronizowanie raportów z centrali...");
          this.reportsModule.httpSyncReportsFromCentral().then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    generateReport(reportGuid, name) {
      Swal.fire({
        title: "Generowanie raportu",
        text: "Czy na pewno wygenerować raport \"" + name + "\"?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Generuj",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Generowanie raportu...");
          this.reportsModule.httpGenerateReport(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    fetchDataFromDrugstores(reportGuid, name) {
      Swal.fire({
        title: "Pobieranie danych z aptek",
        text: "Czy na pewno pobrać dane z aptek dla raportu \"" + name + "\"?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Pobierz",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Pobieranie danych z aptek...");
          this.reportsModule.httpFetchDataFromDrugstores(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    importFetchedFiles(reportGuid, name) {
      Swal.fire({
        title: "Import pobranych plików",
        text: "Czy na pewno zaimportować pobrane pliki dla raportu \"" + name + "\"?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Importuj",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Importowanie plików...");
          this.reportsModule.httpImportFetchedFiles(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    exportFullData(reportGuid, name) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Eksportowanie danych raportu \"" + name + "\"...");
      this.reportsModule.httpExportFullData(reportGuid).then(() => {
        this.refreshReportsList();
      });
    },

    sendReportByEmail(reportGuid, name) {
      Swal.fire({
        title: "Wysyłanie raportu emailem",
        text: "Czy na pewno wysłać raport \"" + name + "\" przez email?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Wyślij",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Wysyłanie raportu emailem...");
          this.reportsModule.httpSendReportByEmail(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    sendReportByFtp(reportGuid, name) {
      Swal.fire({
        title: "Wysyłanie raportu przez FTP",
        text: "Czy na pewno wysłać raport \"" + name + "\" przez FTP?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Wyślij",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Wysyłanie raportu przez FTP...");
          this.reportsModule.httpSendReportByFtp(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    resetReportData(reportGuid, name) {
      Swal.fire({
        title: "Resetowanie danych raportu",
        text: "Czy na pewno zresetować dane raportu \"" + name + "\"? Operacja jest nieodwracalna!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Resetuj",
        customClass: { container: "swal-highest" },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Resetowanie danych raportu...");
          this.reportsModule.httpResetReportData(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    cleanOldReportFiles(reportGuid, name) {
      Swal.fire({
        title: "Czyszczenie starych plików",
        text: "Czy na pewno wyczyścić stare pliki raportu \"" + name + "\"?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        cancelButtonText: "Anuluj",
        confirmButtonText: "Wyczyść",
        customClass: { container: "swal-highest" },
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Czyszczenie plików raportu...");
          this.reportsModule.httpCleanOldReportFiles(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    showFolderInfo(reportGuid) {
      this.folderInfoData = null;
      this.showFolderInfoModal = true;
      this.reportsModule.httpGetReportFolderInfo(reportGuid).then((response) => {
        if (response && response.status === 200) {
          this.folderInfoData = response.data.payload;
        }
      });
    },

    deleteReport(reportGuid, name) {
      Swal.fire({
        title: "Usunąć raport?",
        text: "Czy na pewno usunąć raport \"" + name + "\"? Operacja jest nieodwracalna!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak, usuń",
        customClass: { container: "swal-highest" },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Usuwanie raportu...");
          this.reportsModule.httpDeleteReport(reportGuid).then(() => {
            this.refreshReportsList();
          });
        }
      });
    },

    buildTableData() {
      const reportsList = JSON.parse(JSON.stringify(this.reportsModule.getReportsList));

      const rows = reportsList.map((item) => {
        const row = Object.assign({}, item);

        row.actions = [];
        if (item.canGenerate) {
          row.actions.push({
            icon: "fas fa-play",
            action: "generate",
            enabled: true,
            tooltip: "Generuj raport",
            class: "btn btn-success btn-sm table-actions-button",
          });
        }
        if (item.canFetchData) {
          row.actions.push({
            icon: "fas fa-cloud-download-alt",
            action: "fetch-data-from-ftp",
            enabled: true,
            tooltip: "Pobierz dane aptek z serwera FTP",
            class: "btn btn-primary btn-sm table-actions-button",
          });
        }
        if (item.canReset) {
          row.actions.push({
            icon: "fas fa-undo-alt",
            action: "reset-data",
            enabled: true,
            tooltip: "Resetuj dane raportu",
            class: "btn btn-warning btn-sm table-actions-button",
          });
        }
        if (item.canDelete) {
          row.actions.push({
            icon: "fas fa-trash",
            action: "delete",
            enabled: true,
            tooltip: "Usuń raport",
            class: "btn btn-danger btn-sm table-actions-button",
          });
        }
        return row;
      });

      this.tableData = {
        headers: this.availableHeaders,
        massActions: [],
        data: rows,
      };
    },

    refreshReportsList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy raportów.");
      this.reportsModule.setReportsList([]);
      this.refreshTable = false;

      this.reportsModule.httpGetReportsList({
        page: this.currentPage,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection,
        searchAndFilterRequest: this.searchAndFilterRequest,
      }).then(() => {
        this.buildTableData();
        this.refreshTable = true;
      });
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.refreshReportsList();
      },
      deep: true,
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetWorkingProfile().then(() => {
        this.refreshReportsList();
      })
    });

  },
};
</script>

<style scoped>
.reports-list-stage {
  margin-left: 2px;
  margin-right: 2px;
}

.reports-list-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}
</style>
